import React, { useState, FC } from "react";
import "./style.css";

interface GenericToggleProps {
  initialValueOfIsOn: boolean;
  onToggle: (newValue: boolean) => void;
  onText: string;
  offText: string;
  hasText: boolean;
  disabled?: boolean;
}

const GenericToggle: FC<GenericToggleProps> = ({
  initialValueOfIsOn,
  onToggle,
  onText = "Enable",
  offText = "Disable",
  hasText = true,
  disabled = false,
}) => {
  const [isOn, setIsOn] = useState(initialValueOfIsOn);

  const handleToggle = () => {
    const newValue = !isOn;
    setIsOn(newValue);
    if (onToggle) {
      onToggle(newValue);
    }
  };

  return (
    <div className="switchContainer">
      <label className="switch">
        <input
          type="checkbox"
          checked={isOn}
          onChange={() => null}
          disabled={disabled}
        />
        <span
          onClick={disabled ? undefined : handleToggle}
          className={`slider round${disabled ? " disabled" : ""}`}
        ></span>
      </label>
      {hasText ? (
        <span className="spaceLeft">{isOn ? onText : offText}</span>
      ) : null}
    </div>
  );
};

export default GenericToggle;
